import { render, staticRenderFns } from "./PublicDisplayShortLinkPage.vue?vue&type=template&id=5ffccf60"
import script from "./PublicDisplayShortLinkPage.vue?vue&type=script&lang=js"
export * from "./PublicDisplayShortLinkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffccf60')) {
      api.createRecord('5ffccf60', component.options)
    } else {
      api.reload('5ffccf60', component.options)
    }
    module.hot.accept("./PublicDisplayShortLinkPage.vue?vue&type=template&id=5ffccf60", function () {
      api.rerender('5ffccf60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PublicDisplayShortLinkPage.vue"
export default component.exports